import {breakpoints} from "@next/themes"
import {styled} from "@mui/material/styles"

export const DesktopSortContainer = styled("div")`
    grid-area: end;
    padding: 0;
    display: flex;
    justify-content: flex-end;
    min-width: 16rem;
    
    @media (max-width: ${breakpoints.values.lg - 1}px) {
        display: none;
    }
}
`

export default DesktopSortContainer
